export const USER_CONFIGURATION_QUERY = `
query ConfigurationQuery {
  user {
      data {
          id
          isLogged
          email
          ipAddress
          isSubscribed
          abTests {
              key
              value
          }
          cart
          customerGuid
          sessionId
          consent
      }
      messages
  }
}`;
